'use client'

import { useSocialGetUsersQuery } from '@web/gen/feed'
import { useTranslations } from 'next-intl'
import { tw } from 'utils/classnames'
import { AvatarCard } from '@web/app/[locale]/clubhouse/[slug]/members/_components/avatar-card'
import * as React from 'react'

interface EmptyFeedProps {
  onRefresh?: () => void
}

export function EmptyFeed({ onRefresh }: EmptyFeedProps) {
  const t = useTranslations('pages.masterfeed')
  const socialGetUsersQuery = useSocialGetUsersQuery({ input: { limit: 6 } })
  const suggestedUsers = socialGetUsersQuery.data?.socialGetUsers?.users

  return (
    <section
      className={tw(
        'mx-auto max-w-screen-lg  mb-20 rounded-b-2 relative flex w-full justify-center',
      )}
    >
      <div className=" mt-6 flex flex-col max-w-[756px] w-full justify-center items-center">
        <p className="text-cf-grey-1000 text-20 sm:text-[24px] leading-[30px] font-bold">
          {t('empty_feed')}
        </p>
        <p className="text-cf-grey-600 mt-3  text-center text-16 font-normal">
          {t('follow_crafters')}
        </p>
        <div className="flex w-full mt-6 sm:mt-11 item justify-center sm:justify-between ">
          <p className="text-cf-grey-1000 text-20 font-semibold">{t('suggested')}</p>
        </div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 sm:grid-rows-2 gap-4">
          {suggestedUsers?.map(user => {
            return <AvatarCard member={user} isRealData key={user.id} onFollowSuccess={onRefresh} />
          })}
        </div>
      </div>
    </section>
  )
}
